import myRouter from '@/components/pageManage/router';
import apis from './components/pageManage/pageMana/proxy';

// 新开项
let appId = 42;
let appCode = '0' + appId;

// 新APP需要改动的配置

export default {
    appId: appId,
    appCode: appCode,
    myRouter: myRouter, // 项目的路由
    // data: 数据授权 action: 功能授权
    permissionType: 'data', // wake
    dataPermissionCode: '04201',
    dataActionCode: '04201001',
    /**
     * 前台访问权限的判定函数
     * @param argus 与vuex的getters一致
     * @returns {boolean} true：有访问权限
     */
    clientPermission (state, getters, rootState, rootGetters) {
        return getters['access'].includes('04299001');
    },
    /**
     * 应用的首页重定向地址
     * @param argus 与vuex的getters一致
     * @returns {String} redirection
     */
    redirection (state, getters, rootState, rootGetters) {
        if (getters['clientPermission']) {
            return '/front';
        } else if (getters['permission']) {
            return '/pageMana/pageDetail';
        } else {
            return '/1';
        }
    },
    /* 允许在应用授权前，改变权限或初始化配置 */
    beforeAuthorize: [
        function () {
            return apis.install().then(res => {
                if (res.data.length > 0) {
                    window.yxpapi.store.commit('system/mu_siteList', res.data);
                    window.yxpapi.store.commit('system/mu_actionCodes', [{
                        actions: [
                            {
                                code: '04299001',
                                name: '有前台权限',
                            },
                        ],
                        authType: 'custom',
                    }]);
                } else {
                    window.yxpapi.store.commit('system/mu_siteList', []);
                }
            });
        },
    ],
};
